// One request gets everything the site renders.
export const PORTFOLIO_QUERY = `{
  "profile": *[_type == "profile" && _id == "profile"][0]{
    name,
    role,
    bio,
    cvUrl,
    "cvFileUrl": cvFile.asset->url,
    profileImage,
    contacts[]{ _key, type, value },
    github, linkedin, twitter, instagram
  },
  "hobbies": *[_type == "hobby"] | order(orderRank){ _id, name },
  "skills": *[_type == "skill"] | order(orderRank){ _id, name },
  "education": *[_type == "education"] | order(orderRank){ _id, institution },
  "experience": *[_type == "experience"] | order(orderRank){ _id, company, duration },
  "certificates": *[_type == "certificate"] | order(orderRank){ _id, title, image },
  "projects": *[_type == "project"] | order(order asc, _createdAt asc){
    _id, name, description, link, tech, image
  }
}`;
